import { inr } from "@/lib/api";

export default function BalanceStrip({ balance }) {
  const b = balance || {};
  const due = b.outstanding || 0;
  const items = [["Agreed treatment cost", b.treatment_total, "balance-agreed"], ["Paid", b.payments, "balance-paid"], ["Discounts", b.discounts, "balance-discounts"], ["Refunds", b.refunds, "balance-refunds"]];
  return (
    <section className="balance-strip" data-testid="balance-strip">
      {items.map(([l, v, tid]) => <div key={l}><span>{l}</span><b data-testid={tid}>{inr(v)}</b></div>)}
      <div className={due > 0 ? "balance-total due" : "balance-total"}>
        <span>{due < 0 ? "Advance in credit" : "Outstanding"}</span>
        <b data-testid="balance-outstanding">{inr(Math.abs(due))}</b>
        <small>Agreed − discounts − paid + refunds</small>
      </div>
    </section>
  );
}
